import {Component, ElementRef, inject, OnInit, QueryList, ViewChildren} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";
import {NgOptimizedImage} from "@angular/common";
import {LocaleService} from "../../../../locale/locale.service";
import {FileUploadCategory} from "../../../../interfaces/file-upload-category";
import {FileUploadService} from "../../../../services/file-upload.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {ImageComponent} from "../../../common/image/image.component";
import {SpinnerComponent} from "../../../common/spinner/spinner.component";
import {UserType} from "../../../../enums/user-type";


@Component({
  selector: 'app-document-upload-overview',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    NgOptimizedImage,
    ImageComponent,
    SpinnerComponent
  ],
  templateUrl: './document-upload-overview.component.html',
  styleUrl: './document-upload-overview.component.css'
})
export class DocumentUploadOverviewComponent implements OnInit {
  locale = inject(LocaleService);
  private fileUploadService = inject(FileUploadService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  public fileUploads: (FileUploadCategory & { isLoading: boolean })[] = [];
  public expandDisclaimer: boolean = false;
  public showError: boolean = false;
  @ViewChildren('fileInput') fileInputs: QueryList<ElementRef<HTMLInputElement>> | undefined;


  constructor() {
    this.initDefaultFileUploads();
  }

  private initDefaultFileUploads() {
    let minimumImageCount = this.claimService.claimReport().userType === UserType.FirstParty ? 0 : 0;
    this.fileUploads = [
      {
        header: this.locale.currentTranslation.documentUploadOverviewHeadline1,
        caption: this.locale.currentTranslation.documentUploadOverviewCaption1,
        imageUrls: [],
        minimumImageCount: minimumImageCount,
        isLoading: false,
      },
      {
        header: this.locale.currentTranslation.documentUploadOverviewHeadline2,
        caption: this.locale.currentTranslation.documentUploadOverviewCaption2,
        imageUrls: [],
        minimumImageCount: 0,
        isLoading: false,
      },
      {
        header: this.locale.currentTranslation.documentUploadOverviewHeadline3,
        caption: this.locale.currentTranslation.documentUploadOverviewCaption3,
        imageUrls: [],
        minimumImageCount: 0,
        isLoading: false,
      },
      {
        header: this.locale.currentTranslation.documentUploadOverviewHeadline4,
        caption: this.locale.currentTranslation.documentUploadOverviewCaption4,
        imageUrls: [],
        minimumImageCount: 0,
        isLoading: false,
      },
      {
        header: this.locale.currentTranslation.documentUploadOverviewHeadline5,
        caption: this.locale.currentTranslation.documentUploadOverviewCaption5,
        imageUrls: [],
        minimumImageCount: 0,
        isLoading: false,
      }
    ]
  }

  ngOnInit(): void {
    this.initDefaultFileUploads();
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport().fileUploads) {
        this.fileUploads = this.claimService.claimReport()?.fileUploads?.map(fileUpload => ({
          ...fileUpload,
          isLoading: false
        })) ?? [];
      }
    })
  }

  triggerFileInput(index: number): void {
    if (this.fileInputs) {
      const fileInput = this.fileInputs.toArray()[index];
      fileInput.nativeElement.click();
    }
  }

  onFileSelected(event: Event, category: (FileUploadCategory & { isLoading: boolean })): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      category.isLoading = true;
      const file = input.files[0];
      this.fileUploadService.uploadImage(file, category.header).subscribe({
        next: (res: any) => {
          category.imageUrls.push(res["key"])
        },
        complete: () => {
          category.isLoading = false;
        }
      });
    }
  }

  nextClicked() {
    this.checkForError();
    if (!this.showError) {
      this.claimService.updateClaimReport({
        fileUploads: this.fileUploads.map(
          ({isLoading, ...fileUploads}) => fileUploads)
      });
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['document-upload-police-report']);
      });
    }
  }

  checkForError() {
    let result = false;
    this.fileUploads.forEach(file => {
      if (file.imageUrls.length < file.minimumImageCount) {
        result = true;
      }
    })
    this.showError = result;
  }

  removeImage(fileUploadCategory
              :
              FileUploadCategory, imageUrl
              :
              string
  ) {
    fileUploadCategory.imageUrls.splice(fileUploadCategory.imageUrls.indexOf(imageUrl), 1);
  }

}
